import { defineMessages } from "react-intl";

export const scope = "components.DepositMessages";

export const messages = defineMessages({
  comission: {
    id: `${scope}.comission`,
    defaultMessage: "Comision: { fee }",
  },
  min_deposit_amount: {
    id: `${scope}.min_deposit_amount`,
    defaultMessage:
      "Solo aceptaremos transferencias mayores a { min_deposit } { currency }",
  },
  memo: {
    id: `${scope}.memo`,
    defaultMessage: "El memo es obligatorio, sin él tu depósito se perderá.",
  },
});
